module.exports = __webpack_public_path__ + "img/event-atelier-solo-blues.4da59be.jpg";